export const BRONZE = 'bronze';
export const SILVER = 'silver';
export const ORANGE = 'orange';
